import React from 'react';
import { Container } from 'react-bootstrap';
import { Heart, BookOpen, Users, Building2 } from 'lucide-react';
import '../../../assets/css/student/home/NGOSection.css';

function NGOSection() {
  const partners = [
    {
      id: 1,
      name: 'EDHI',
      subtitle: 'FOUNDATION',
      icon: Heart,
      color: '#e74c3c'
    },
    {
      id: 2,
      name: 'TCF',
      subtitle: 'The Citizens Foundation',
      icon: BookOpen,
      color: '#3498db'
    },
    {
      id: 3,
      name: 'AKHUWAT',
      subtitle: 'Interest Free Loans',
      icon: Users,
      color: '#27ae60'
    },
    {
      id: 4,
      name: 'SHAUKAT',
      subtitle: 'KHANUM',
      icon: Building2,
      color: '#9b59b6'
    }
  ];

  return (
    <section className="ngo-partners-section">
      <Container>
        <div className="ngo-partners-content">
          <p className="ngo-partners-heading">
            FOSTERING UNITY AND COLLABORATION WITH OUR DEDICATED PARTNERS
          </p>
          
          <div className="ngo-partners-logos">
            {partners.map((partner) => {
              const IconComponent = partner.icon;
              return (
                <div key={partner.id} className="ngo-partners-logo-box">
                  <div className="ngo-partners-logo-content">
                    <div 
                      className="ngo-partners-logo-icon"
                      style={{ '--icon-color': partner.color }}
                    >
                      <IconComponent size={40} strokeWidth={2} />
                    </div>
                    <div className="ngo-partners-logo-text">
                      <span className="ngo-partners-logo-name">{partner.name}</span>
                      <span className="ngo-partners-logo-subtitle">{partner.subtitle}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
}

export default NGOSection;